var map = {
	"./News/1.JPG": 5329,
	"./News/10.JPG": 733,
	"./News/11.jpg": 5633,
	"./News/12.jpg": 9846,
	"./News/13.jpeg": 5132,
	"./News/14.jpg": 8096,
	"./News/15.jpeg": 9714,
	"./News/16.jpeg": 7231,
	"./News/2.jpg": 9305,
	"./News/21.jpeg": 1809,
	"./News/22.jpg": 1463,
	"./News/23.jpeg": 7095,
	"./News/24.jpeg": 8990,
	"./News/25.jpeg": 373,
	"./News/26.jpeg": 516,
	"./News/27.jpeg": 5723,
	"./News/28.jpeg": 4034,
	"./News/29.jpeg": 6233,
	"./News/3.jpg": 5164,
	"./News/33.jpg": 2665,
	"./News/34.jpg": 826,
	"./News/35.jpg": 1639,
	"./News/36.1.jpg": 1179,
	"./News/36.jpg": 1064,
	"./News/37.jpg": 3429,
	"./News/38.jpg": 2390,
	"./News/39v.mp4": 6646,
	"./News/4.jpg": 5399,
	"./News/40.1.jpg": 2704,
	"./News/40.jpg": 1303,
	"./News/40v.mp4": 3330,
	"./News/5.jpg": 3466,
	"./News/6.jpg": 693,
	"./News/7.jpg": 3080,
	"./News/8.jpg": 2819,
	"./News/9.jpg": 8054,
	"./News/add-thumb-2.jpg": 7016,
	"./News/block1.jpg": 1987,
	"./News/block2.jpeg": 9693,
	"./News/block3.jpeg": 8374,
	"./News/business.jpg": 3157,
	"./News/categories-list-bg-e.jpeg": 751,
	"./News/categories-list-bg-f.jpeg": 6514,
	"./News/categories-list-bg-h.jpeg": 9572,
	"./News/categories-list-bg-n.jpeg": 5162,
	"./News/categories-list-bg-t.jpg": 159,
	"./News/certificate.jpeg": 3231,
	"./News/latest-post-11.jpeg": 4121,
	"./News/latest-post-12.jpeg": 6440,
	"./News/latest-post-13.jpeg": 4959,
	"./News/latest-post-1t.jpeg": 5462,
	"./News/newyear.jpeg": 9483,
	"./News/purchase.jpg": 5569,
	"./News/uk-express.jpg": 4928,
	"./News/uk-express.png": 5732,
	"./Talukas/t-ankola.png": 9442,
	"./Talukas/t-bhatkal.png": 8117,
	"./Talukas/t-dandeli.jpg": 9131,
	"./Talukas/t-haliyal.png": 4544,
	"./Talukas/t-honnavar.png": 4667,
	"./Talukas/t-joida.png": 8029,
	"./Talukas/t-karwar.png": 6748,
	"./Talukas/t-kumta.png": 8498,
	"./Talukas/t-mundgod.png": 7848,
	"./Talukas/t-siddapur.png": 6098,
	"./Talukas/t-sirsi.png": 8136,
	"./Talukas/t-yellapur.png": 5672,
	"./about-play-thumb.png": 2010,
	"./about-thumb.jpg": 5291,
	"./archived-about.png": 6349,
	"./author-item-1.jpg": 4994,
	"./author-item-2.jpg": 3949,
	"./author-item-3.jpg": 4736,
	"./author-item-4.jpg": 8691,
	"./author-item-5.jpg": 3430,
	"./author-item-6.jpg": 3041,
	"./author-user.jpg": 7528,
	"./blog-details-bg.jpg": 8600,
	"./blog-details-thumb-1.jpg": 175,
	"./blog-details-thumb-2.jpg": 6560,
	"./blog-details-thumb-3.jpg": 7693,
	"./blog-details-thumb-4.jpg": 2934,
	"./blog-details-thumb-5.jpg": 9395,
	"./blog-project-1.jpg": 8357,
	"./blog-project-2.jpg": 1018,
	"./blog-project-3.jpg": 23,
	"./categories-list-bg-1.jpg": 9110,
	"./categories-list-bg-2.jpg": 8689,
	"./categories-list-bg-3.jpg": 644,
	"./categories-list-bg-4.jpg": 8607,
	"./categories-list-bg-5.jpg": 674,
	"./categories-news-1.jpg": 1757,
	"./categories-news-2.jpg": 2498,
	"./categories-news-3.jpg": 5167,
	"./client-thumb.png": 5321,
	"./editors-pack-thumb-1.jpg": 8666,
	"./editors-pack-thumb-10.jpg": 728,
	"./editors-pack-thumb-11.jpg": 5045,
	"./editors-pack-thumb-12.jpg": 2970,
	"./editors-pack-thumb-2.jpg": 6517,
	"./editors-pack-thumb-3.jpg": 8904,
	"./editors-pack-thumb-4.jpg": 491,
	"./editors-pack-thumb-5.jpg": 9182,
	"./editors-pack-thumb-6.jpg": 5129,
	"./editors-pack-thumb-7.jpg": 3516,
	"./editors-pack-thumb-8.jpg": 4351,
	"./editors-pack-thumb-9.jpg": 7970,
	"./editors-pack-thumb.jpg": 4388,
	"./faq-bg.jpg": 2651,
	"./favicon.ico": 804,
	"./favorites-categories-1.png": 9033,
	"./favorites-categories-2.png": 2946,
	"./favorites-categories-3.png": 4075,
	"./favorites-categories-4.png": 4164,
	"./favorites-categories-5.png": 7197,
	"./favorites-categories-6.png": 5990,
	"./favorites-categories-7.png": 8655,
	"./favorites-categories-8.png": 3704,
	"./favorites-categories-9.png": 4833,
	"./favorites-categories.jpg": 3503,
	"./feature-news-thuimb-2.jpg": 4998,
	"./feature-news-thuimb-3.jpg": 1459,
	"./feature-news-thuimb-4.jpg": 8624,
	"./feature-news-thuimb.jpg": 9039,
	"./featured-item-1.jpg": 7823,
	"./featured-item-2.jpg": 4096,
	"./featured-item-3.jpg": 5341,
	"./featured-trending-thumb-1.jpg": 3482,
	"./featured-trending-thumb-2.jpg": 709,
	"./footer-gallery-1.jpg": 9009,
	"./footer-gallery-2.jpg": 7590,
	"./footer-gallery-3.jpg": 2291,
	"./footer-gallery-4.jpg": 7488,
	"./footer-gallery-5.jpg": 4589,
	"./footer-gallery-6.jpg": 2450,
	"./hero-bg-1.jpeg": 2178,
	"./hero-bg-2.jpg": 2082,
	"./hero-bg-3.jpg": 3791,
	"./icon/1.png": 672,
	"./icon/2.png": 9003,
	"./icon/3.png": 4786,
	"./icon/4.png": 7293,
	"./icon/icon-1.png": 8988,
	"./icon/icon-2.png": 743,
	"./icon/icon-3.png": 1518,
	"./icon/icon-4.png": 9233,
	"./icon/post-bars.png": 2916,
	"./icon/quote-bg.png": 13,
	"./instagram-bg.jpg": 591,
	"./latest-news-thumb-1.jpg": 677,
	"./latest-news-thumb-2.jpg": 8074,
	"./latest-news-thumb-3.jpg": 2535,
	"./latest-news-thumb-4.jpg": 8188,
	"./latest-news-thumb.jpg": 7547,
	"./latest-post-1.jpg": 5441,
	"./latest-post-2.jpg": 9590,
	"./latest-post-3.jpg": 9699,
	"./latest-post-4.jpg": 2163,
	"./logo-2.png": 8215,
	"./logo-3.png": 6078,
	"./logo-4.png": 641,
	"./logo-5.png": 6219,
	"./logo-6.png": 2960,
	"./logo-7.png": 746,
	"./logo.png": 2806,
	"./main-post-thumb-1.jpg": 2500,
	"./main-post-thumb-1.png": 9536,
	"./main-post-thumb-2.jpg": 4131,
	"./main-post-thumb-2.png": 7867,
	"./main-post-thumb-3.jpg": 966,
	"./main-post-thumb-4.jpg": 2429,
	"./main-post-thumb-5.jpg": 3200,
	"./main-post-thumb-6.jpg": 6815,
	"./most-view-1.png": 4332,
	"./most-view-2.png": 1911,
	"./news-portal-1.jpg": 9113,
	"./news-portal-1.png": 4145,
	"./news-portal-2.jpg": 1998,
	"./news-portal-2.png": 3066,
	"./news-portal-3.jpg": 43,
	"./news-slider-1.jpg": 676,
	"./news-slider-2.jpg": 4835,
	"./news-slider-3.jpg": 5993,
	"./news-slider-4.jpg": 3133,
	"./news-slider-5.jpg": 2000,
	"./newsletter-bg-2.jpg": 6977,
	"./newsletter-bg.jpg": 3976,
	"./newsletter-news-1.jpg": 9230,
	"./newsletter-news-2.jpg": 6345,
	"./newsletter-news.jpg": 6115,
	"./populer-news-1.jpg": 2220,
	"./populer-news-10.jpg": 3470,
	"./populer-news-11.jpg": 8251,
	"./populer-news-12.jpg": 1804,
	"./populer-news-2.jpg": 5019,
	"./populer-news-3.jpg": 4862,
	"./populer-news-4.jpg": 7749,
	"./populer-news-5.jpg": 136,
	"./populer-news-6.jpg": 2455,
	"./populer-news-7.jpg": 522,
	"./populer-news-8.jpg": 7249,
	"./populer-news-9.jpg": 7300,
	"./recent-news-1.jpg": 5766,
	"./recent-news-2.jpg": 3521,
	"./recent-news-3.jpg": 9188,
	"./recent-news-4.jpg": 623,
	"./recently-viewed-thumb-1.jpg": 6155,
	"./recently-viewed-thumb-2.jpg": 4172,
	"./recently-viewed-thumb-3.jpg": 5225,
	"./recently-viewed-thumb-4.jpg": 4330,
	"./recently-viewed-thumb.jpg": 8017,
	"./social-news-1.jpg": 2254,
	"./social-news-2.jpg": 5961,
	"./social-news-3.jpg": 588,
	"./space-bg-1.png": 4407,
	"./space-bg-2.png": 5932,
	"./space-bg-3.jpg": 3285,
	"./space-bg-4.jpg": 8286,
	"./space-bg-5.jpg": 9771,
	"./space-bg-6.jpg": 3324,
	"./space-thumb-2.jpg": 6911,
	"./space-thumb.jpg": 8106,
	"./top-bar-bg.jpg": 4856,
	"./top-news-item-1.jpg": 4312,
	"./top-news-item-2.jpg": 2711,
	"./top-news-item-3.jpg": 5226,
	"./top-news-item-4.jpg": 5913,
	"./trending-news-item-1.jpg": 5106,
	"./trending-news-item-2.jpg": 685,
	"./trending-news-item-3.jpg": 9440,
	"./trending-news-list-thumb-1.jpg": 2248,
	"./trending-news-list-thumb-1.png": 4236,
	"./trending-news-list-thumb-2.jpg": 6471,
	"./trending-news-list-thumb-3.jpg": 9629,
	"./trending-thumb.png": 3135,
	"./trending-today-bg.jpg": 7894,
	"./trending-today-thumb-1.png": 1733,
	"./trending-today-thumb-2.png": 5982,
	"./trending-today-thumb-3.png": 8471,
	"./trending-today-thumb-4.png": 8856,
	"./trending-video-thumb-1.jpg": 3267,
	"./trending-video-thumb-2.jpg": 7988,
	"./trending-video-thumb-3.jpg": 6033,
	"./trending-video-thumb.jpg": 2409,
	"./trending.jpeg": 8037,
	"./user-1.png": 6064,
	"./user-2.jpg": 8323,
	"./user-2.png": 1467,
	"./user-3.png": 7810,
	"./user.jpg": 1478,
	"./video-post-1.jpg": 1393,
	"./video-post-2.jpg": 1782,
	"./video-post-thumb-1.jpg": 1074,
	"./video-post-thumb-1.png": 8454,
	"./video-post-thumb-2.png": 9661,
	"./video-post-thumb-3.png": 2980,
	"./video-post-thumb-4.png": 2891,
	"./video-post-thumb-5.png": 1762,
	"./video-post-thumb.jpg": 6252,
	"./video-post.jpg": 3823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;